<template>
  <div class="details">
    <h4 class="text-center">Molibdênio</h4>
    <h5>O que é o Molibdênio?</h5><br/>
    <p>O molibdênio auxilia um pequeno número de enzimas, as proteínas que ajudam as reações químicas que ocorrem no corpo. A mais importante dessas enzimas é a sulfito oxidase, que está envolvida no metabolismo dos aminoácidos (os blocos de construção da proteína) que contêm enxofre.</p>
    <h5>Por que o Molibdênio é importante?</h5>
    <p>O molibdênio é considerado importante para a função celular normal. É encontrado em leguminosas como feijão, lentilha e ervilha, bem como em grãos. Frutas e vegetais tendem a ter baixo teor de molibdênio.</p>
  </div>
</template>
